module.exports = __webpack_public_path__ + "img/VIP.9bd1ca98.png";